import React, { useState } from "react";
import { serviceFaqs } from "../../thirdUtils/constant";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import img from "../../thirdAssets/Images/faqs.jpg"
import serviceFaqsLogo from "../../thirdAssets/Images/service-faq-logo.png"

const Faq = (props) => {
    const [activeIndex, setActiveIndex] = useState(serviceFaqs.length - 1);
    const { selectedLanguage, language, secondClass } = props;
    const isELSelect = language?.language === 'english';
    const isAlSelect = language?.language === 'arabic';

    const toggleActiveIndex = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    return (
        <div className={`third-design-faq-container ${secondClass}`}>
            <div className="third-design-service-faqs-left-div">
                <h2 className="third-design-heading-1" data-aos="fade-right"
                    data-aos-easing="ease-out-cubic"
                    data-aos-delay="100"
                    data-aos-offset="0"
                    data-aos-duration="1500">{selectedLanguage?.txt_faq}</h2>
                <h1 className="third-design-heading-2">{selectedLanguage?.txt_general_question}</h1>
                <p className="third-design-heading-text">{selectedLanguage?.txt_it_is_important_to_take_care}
                </p>
                <div className="third-design-service-faqs-container">
                    {serviceFaqs.map((v, i) => (
                        <div key={i} className="third-design-service-faqs-div">
                            <div className={activeIndex === i ? "third-design-service-faqs-question-div third-design-service-faqs-active-question-div" : "third-design-service-faqs-question-div"} onClick={() => toggleActiveIndex(i)}>
                                <div>
                                    <h2 className="third-design-service-faqs-question">
                                        {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                    </h2>
                                    <button>
                                        {activeIndex === i ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                    </button>
                                </div>
                            </div>
                            {activeIndex === i ? <p className="service-faq-answer">
                                {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                            </p> : null}
                        </div>
                    ))}
                </div>
            </div>
            <div className="third-design-service-faqs-right-div">
                <div className="service-faqs-img">
                    <img src={img} alt="" />
                    <div className="service-faqs-img-bottom-circle">
                        <img src={serviceFaqsLogo} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faq;

